export default __webpack_public_path__ + "static/media/leparisien.de1468f5.jpg";